<template>
    <div class="ma-4">
        <v-snackbar
            v-model="msg"
            top
            :color="snackbarColor"
            :timeout="3000"
            elevation="4"
            class="rounded-lg"
        >
            <div class="d-flex align-center">
                <v-icon class="mr-2">{{
                    snackbarColor === "success" ? "mdi-check-circle" : "mdi-alert"
                }}</v-icon>
                {{ text }}
            </div>
            <template v-slot:action="{ attrs }">
                <v-btn icon small v-bind="attrs" @click="msg = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>

        <v-card class="rounded-lg">
            <v-app-bar flat dense color="grey lighten-4" class="rounded-t-lg px-3">
                <v-btn icon small class="mr-2 grey lighten-3" @click="$router.go(-1)">
                    <v-icon>navigate_before</v-icon>
                </v-btn>

                <span class="text-h6 font-weight-medium grey--text text--darken-3">
                    Missing Medication Verification Report
                </span>

                <v-spacer></v-spacer>

                <report-list-actions
                    :reportOptions="reportOptions"
                    :downloadFilename="reportListFilename"
                    class="mr-2"
                />
            </v-app-bar>

            <v-divider></v-divider>

            <v-card-text class="pa-6 grey lighten-5">
                <v-row dense>
                    <v-col cols="12" md="2">
                        <v-menu
                            ref="calendarMenu"
                            v-model="calendarMenu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filters.startDate"
                                    label="Start Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules="requiredField"
                                    outlined
                                    dense
                                    hide-details
                                    class="rounded-lg"
                                    background-color="white"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filters.startDate"
                                no-title
                                scrollable
                                :rules="requiredField"
                                class="rounded-lg"
                            >
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="calendarMenu = false">
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.calendarMenu.save(date)"
                                >
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" md="2">
                        <v-menu
                            ref="calendar2Menu"
                            v-model="calendar2Menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="filters.endDate"
                                    label="End Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules="requiredField"
                                    outlined
                                    dense
                                    hide-details
                                    class="rounded-lg"
                                    background-color="white"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filters.endDate"
                                no-title
                                scrollable
                                :rules="requiredField"
                                class="rounded-lg"
                            >
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="calendar2Menu = false">
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.calendar2Menu.save(date)"
                                >
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" md="2">
                        <v-select
                            label="Client Status"
                            :items="clientStatuses"
                            v-model="filters.clientStatus"
                            clearable
                            @change="getMARs"
                            outlined
                            dense
                            hide-details
                            class="rounded-lg"
                            background-color="white"
                        />
                    </v-col>

                    <v-col cols="12" md="3">
                        <v-select
                            label="Select a Client"
                            :items="filteredClients"
                            item-text="Name"
                            item-value="_id"
                            v-model="filters.ClientID"
                            clearable
                            @change="getMARs"
                            outlined
                            dense
                            hide-details
                            class="rounded-lg"
                            background-color="white"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="3">
                        <v-btn
                            color="primary"
                            block
                            height="40"
                            class="rounded-lg"
                            :loading="isLoading"
                            elevation="1"
                            @click="getMARs()"
                        >
                            <v-icon left>mdi-magnify</v-icon>
                            Search
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>

            <!-- Data Table -->
            <v-card-text class="pa-6">
                <v-data-table
                    :headers="headers"
                    :items="mars"
                    class="elevation-1 rounded-lg"
                    :loading="isLoading"
                    loading-text="Loading MAR"
                    :server-items-length="itemCount"
                    :page="page"
                    :pageCount="pageCount"
                    :options.sync="options"
                    :footer-props="{
                        'items-per-page-options': [10, 20, 30, 40, 50, 100],
                        showFirstLastPage: true,
                        'items-per-page-text': 'Rows per page:',
                        class: 'rounded-lg',
                    }"
                >
                    <!-- <template v-slot:item.select="{ item }">
                      <v-btn
                        x-small
                        class="white--text"
                        color="#2b3990"
                        @click="viewMAR(item)"
                      >
                        view
                      </v-btn>
                    </template> -->
                </v-data-table>
            </v-card-text>
        </v-card>

        <!-- <MarSignDialog
            ref="marDialog"
            :dialog="dialog"
            @close="dialog = false"
            @updateMAR="updateMAR"
            @verifiedBySignature="verifiedBySignature"
            :verifiedSignature="newVerifiedBy"
          /> -->

        <div id="print">
            <report-header>
                <h2>Missing Mediciation Verification Report</h2>
            </report-header>
            <v-data-table
                :headers="headers"
                :items="mars"
                sort-by="Name"
                sort-desc
                class="elevation-1"
                :loading="isLoading"
                loading-text="Loading MAR"
                :server-items-length="itemCount"
                @pagination="getMARs"
                @update:options="getMARs"
            />
        </div>
    </div>
</template>
<script>
import axios from "axios";
// import MarSignDialog from "@/components/medications/MAR/MarSignDialog";
import momentTz from "moment-timezone";
import moment from "moment";
import {STATUS_ARRAY} from '../../enums/UserStatusEnum';
import ReportHeader from '@/components/Report/ReportHeader.vue';
import {DateTime} from 'luxon';
import ReportListActions from '@/components/Report/ReportListActions.vue'
import {SORT_ORDER} from '../../constants/MongoDBConstants.js';

const url = require("../../client_config/config").url;

export default {
    components: {
        // MarSignDialog,
        ReportHeader,
        ReportListActions,
    },
    data: () => ({
        headers: [
            {
                text: "Date",
                align: "start",
                sortable: true,
                value: "Date",
            },
            {text: "Client", value: "Client"},
            {text: "Verified By", value: "VerifiedBy"},
            {text: "Medication", value: "Medication"},
            {text: "Notes", value: "Notes"},
            {text: "Signature", value: "Signature"},
            {text: "", value: "select"},
        ],
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        clients: [],
        mars: [],
        startDate: "",
        endDate: "",
        ClientID: "",
        calendarMenu: false,
        calendar2Menu: false,
        report: "",
        client: "",
        isLoading: false,
        requiredField: [(v) => !!v || "This is required"],
        userState: localStorage.getItem("userState"),
        dialog: false,
        switch1: false,
        switch2: false,
        newPRNNote: "",
        newPRNIsEffective: "",
        showPRN: false,
        newMedication: "",
        newMedicationId: "",
        newAmountAdministered: "",
        newAdminTime: "",
        unsignedList: [],
        unsignedNewList: [],
        newNotes: "",
        newException: "",
        newSignature: "",
        newSignatureData: "",
        newSignatureDataAdd: "",
        newVerifiedBy: "",
        newDate: "",
        newActualAdminTime: "",
        directCareStaff: false,
        adminTime: [
            "12:00am",
            "1:00am",
            "2:00am",
            "3:00am",
            "4:00am",
            "5:00am",
            "6:00am",
            "7:00am",
            "8:00am",
            "9:00am",
            "10:00am",
            "11:00am",
            "12:00pm",
            "1:00pm",
            "2:00pm",
            "3:00pm",
            "4:00pm",
            "5:00pm",
            "6:00pm",
            "7:00pm",
            "8:00pm",
            "9:00pm",
            "10:00pm",
            "11:00pm",
            "PRN",
        ],
        msg: false,
        text: "",
        color: "",
        titleForm: "New Inventory Item",
        editMAR: false,
        marID: null,
        menu2: false,
        actualAdminTimeDialog: false,
        actualTime: "",

        //pagination
        paginationInfo: {},
        page: 1,
        pageCount: 1,
        itemCount: 0,
        options: {},
        clientStatus: "",
        clientStatuses: STATUS_ARRAY,
        filteredClients: [],
        filters: {
            clientStatus: '',
            startDate: '',
            endDate: '',
            ClientID: '',
        },
        snackbarColor: "success",
    }),

    computed: {
        staffName() {
            return localStorage.getItem("Name");
        },

        queryParams() {
            let {page, sortBy, sortDesc, itemsPerPage} = this.options;

            let numItems = itemsPerPage || 10;

            let today = DateTime.now();
            let lastMonth = DateTime.now().minus({months: 1});

            let defaultEndDate = today.toFormat('yyyy-MM-dd');
            let defaultStartDate = lastMonth.toFormat('yyyy-MM-dd');
            
            const sortField = Array.isArray(sortBy) ? (sortBy[0] ?? 'Date') : 'Date';
            const sortDirection = Array.isArray(sortDesc) ? (sortDesc[0] ? SORT_ORDER.DESC:SORT_ORDER.ASC) : SORT_ORDER.DESC;
            return {
                startDate: this.filters.startDate || defaultStartDate,
                endDate: this.filters.endDate || defaultEndDate,
                clientID: this.filters.ClientID || "",
                page: page,
                limit: numItems,
                tz: momentTz.tz.guess(),
                sortField: sortField,
                sortDirection: sortDirection,
                clientStatus: this.filters.clientStatus,
                state: this.userState
            };
        },

        reportOptions() {
            let query = {
                name: this.staffName,
            }

            Object.assign(query, this.queryParams);

            return { 
                query: query,
                endpoints: `MAR/unverified/printList`,
                dynamic: true
            }
        },
        reportListFilename() {
            return `Missing Medication Verification Report`
        }
    },

    created() {
        this.getClients();
        this.getFilters();
    },

    watch: {
        clientStatus: function (val) {
            if (val == '' || val == null) this.filteredClients = this.clients;
            else this.filteredClients = this.clients.filter((client) => client.Status == val);
        },

        options: {
            handler() {
                this.getMARs();
            },
            deep: true
        },
        
        filters: {
            handler() {
                this.setFilters();
            },
            deep: true
        }
    },

    methods: {
        initialize() {
            this.clients = [];
        },

        async getClients() {
            let params = {};
            let endpoint = `${url}/clients`;

            const companyIds = localStorage.getItem("userCompanies");

            params["Company:in"] = JSON.parse(companyIds);
            params["State"] = this.userState;

            await axios.get(endpoint, {params}).then((res) => {
                this.clients = res.data.clients;
                this.filteredClients = this.clients;
            });
        },

        close() {
            this.dialog = false;
        },

        viewMAR(item) {
            this.$refs.marDialog.onViewItem(item);
            this.dialog = true;
        },

        async getMARs(item = {page: 1}) {
            this.paginationInfo = item;
            let params = this.queryParams;

            let endpoint = `${url}/MAR/unverified`;

            this.isLoading = true;

            axios
                .get(endpoint, {params})
                .then((response) => {
                    const {docs, totalPages, totalDocs} = response.data.data;

                    this.mars = docs.map((doc) => {
                        doc.Date = moment(doc.Date)
                            .format("MM/DD/YYYY");
                        return doc;
                    });

                    this.pageCount = totalPages;
                    this.itemCount = totalDocs;
                })
                .finally(() => (this.isLoading = false));
        },

        getClientID(item) {
            this.client = item.ClientID;
            window.localStorage.setItem("clientId", this.client);
            console.log(this.client);
        },

        printTable() {
            window.print();
        },

        getFilters() {
            let filters = localStorage.getItem('missingMedicationReportFilter');
            if (filters) {
                this.filters = JSON.parse(filters);
            }
        },

        setFilters() {
            localStorage.setItem('missingMedicationReportFilter', JSON.stringify(this.filters));
        }
    },
};
</script>
<style scoped>
.v-data-table {
  border: 1px solid #e0e0e0;
}

.v-data-table ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table ::v-deep tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.v-btn {
  text-transform: none;
  letter-spacing: 0;
}

.v-text-field ::v-deep .v-input__prepend-inner {
  margin-top: 8px !important;
}

.v-select ::v-deep .v-input__prepend-inner {
  margin-top: 8px !important;
}

.rounded-lg {
  border-radius: 8px !important;
}

.rounded-t-lg {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}
</style>

<style>
#print {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

@media print {
    #print {
        display: block;
        border: 5px solid #f00;
    }

    #print table {
        width: 100%;
    }

    nav.v-navigation-drawer,
    header.v-toolbar,
    button.v-btn,
    div.v-card {
        display: none;
        border: none;
    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }
}
</style>
